package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets17 {
  internal val _6_yehoshua_17_txt: AssetResource by lazy { init__6_yehoshua_17_txt() }

  internal val _6_yehoshua_18_txt: AssetResource by lazy { init__6_yehoshua_18_txt() }

  internal val _6_yehoshua_19_txt: AssetResource by lazy { init__6_yehoshua_19_txt() }

  internal val _6_yehoshua_20_txt: AssetResource by lazy { init__6_yehoshua_20_txt() }

  internal val _6_yehoshua_21_txt: AssetResource by lazy { init__6_yehoshua_21_txt() }

  internal val _6_yehoshua_22_txt: AssetResource by lazy { init__6_yehoshua_22_txt() }

  internal val _6_yehoshua_23_txt: AssetResource by lazy { init__6_yehoshua_23_txt() }

  internal val _6_yehoshua_24_txt: AssetResource by lazy { init__6_yehoshua_24_txt() }

  internal val _7_shoftim_01_txt: AssetResource by lazy { init__7_shoftim_01_txt() }

  internal val _7_shoftim_02_txt: AssetResource by lazy { init__7_shoftim_02_txt() }

  internal val _7_shoftim_03_txt: AssetResource by lazy { init__7_shoftim_03_txt() }

  internal val _7_shoftim_04_txt: AssetResource by lazy { init__7_shoftim_04_txt() }

  internal val _7_shoftim_05_txt: AssetResource by lazy { init__7_shoftim_05_txt() }

  internal val _7_shoftim_06_txt: AssetResource by lazy { init__7_shoftim_06_txt() }

  internal val _7_shoftim_07_txt: AssetResource by lazy { init__7_shoftim_07_txt() }

  internal val _7_shoftim_08_txt: AssetResource by lazy { init__7_shoftim_08_txt() }

  internal val _7_shoftim_09_txt: AssetResource by lazy { init__7_shoftim_09_txt() }

  internal val _7_shoftim_10_txt: AssetResource by lazy { init__7_shoftim_10_txt() }

  internal val _7_shoftim_11_txt: AssetResource by lazy { init__7_shoftim_11_txt() }

  internal val _7_shoftim_12_txt: AssetResource by lazy { init__7_shoftim_12_txt() }

  internal val _7_shoftim_13_txt: AssetResource by lazy { init__7_shoftim_13_txt() }

  internal val _7_shoftim_14_txt: AssetResource by lazy { init__7_shoftim_14_txt() }

  internal val _7_shoftim_15_txt: AssetResource by lazy { init__7_shoftim_15_txt() }

  internal val _7_shoftim_16_txt: AssetResource by lazy { init__7_shoftim_16_txt() }

  internal val _7_shoftim_17_txt: AssetResource by lazy { init__7_shoftim_17_txt() }

  internal val _7_shoftim_18_txt: AssetResource by lazy { init__7_shoftim_18_txt() }

  internal val _7_shoftim_19_txt: AssetResource by lazy { init__7_shoftim_19_txt() }

  internal val _7_shoftim_20_txt: AssetResource by lazy { init__7_shoftim_20_txt() }

  internal val _7_shoftim_21_txt: AssetResource by lazy { init__7_shoftim_21_txt() }

  internal val _8_shemuel_a_01_txt: AssetResource by lazy { init__8_shemuel_a_01_txt() }

  internal val _8_shemuel_a_02_txt: AssetResource by lazy { init__8_shemuel_a_02_txt() }

  internal val _8_shemuel_a_03_txt: AssetResource by lazy { init__8_shemuel_a_03_txt() }

  internal val _8_shemuel_a_04_txt: AssetResource by lazy { init__8_shemuel_a_04_txt() }

  internal val _8_shemuel_a_05_txt: AssetResource by lazy { init__8_shemuel_a_05_txt() }

  internal val _8_shemuel_a_06_txt: AssetResource by lazy { init__8_shemuel_a_06_txt() }

  internal val _8_shemuel_a_07_txt: AssetResource by lazy { init__8_shemuel_a_07_txt() }

  internal val _8_shemuel_a_08_txt: AssetResource by lazy { init__8_shemuel_a_08_txt() }

  internal val _8_shemuel_a_09_txt: AssetResource by lazy { init__8_shemuel_a_09_txt() }

  internal val _8_shemuel_a_10_txt: AssetResource by lazy { init__8_shemuel_a_10_txt() }

  internal val _8_shemuel_a_11_txt: AssetResource by lazy { init__8_shemuel_a_11_txt() }

  internal val _8_shemuel_a_12_txt: AssetResource by lazy { init__8_shemuel_a_12_txt() }

  internal val _8_shemuel_a_13_txt: AssetResource by lazy { init__8_shemuel_a_13_txt() }

  internal val _8_shemuel_a_14_txt: AssetResource by lazy { init__8_shemuel_a_14_txt() }

  internal val _8_shemuel_a_15_txt: AssetResource by lazy { init__8_shemuel_a_15_txt() }

  internal val _8_shemuel_a_16_txt: AssetResource by lazy { init__8_shemuel_a_16_txt() }

  internal val _8_shemuel_a_17_txt: AssetResource by lazy { init__8_shemuel_a_17_txt() }

  internal val _8_shemuel_a_18_txt: AssetResource by lazy { init__8_shemuel_a_18_txt() }

  internal val _8_shemuel_a_19_txt: AssetResource by lazy { init__8_shemuel_a_19_txt() }

  internal val _8_shemuel_a_20_txt: AssetResource by lazy { init__8_shemuel_a_20_txt() }

  internal val _8_shemuel_a_21_txt: AssetResource by lazy { init__8_shemuel_a_21_txt() }

  internal fun values(): List<AssetResource> = listOf(_6_yehoshua_17_txt, _6_yehoshua_18_txt,
      _6_yehoshua_19_txt, _6_yehoshua_20_txt, _6_yehoshua_21_txt, _6_yehoshua_22_txt,
      _6_yehoshua_23_txt, _6_yehoshua_24_txt, _7_shoftim_01_txt, _7_shoftim_02_txt,
      _7_shoftim_03_txt, _7_shoftim_04_txt, _7_shoftim_05_txt, _7_shoftim_06_txt, _7_shoftim_07_txt,
      _7_shoftim_08_txt, _7_shoftim_09_txt, _7_shoftim_10_txt, _7_shoftim_11_txt, _7_shoftim_12_txt,
      _7_shoftim_13_txt, _7_shoftim_14_txt, _7_shoftim_15_txt, _7_shoftim_16_txt, _7_shoftim_17_txt,
      _7_shoftim_18_txt, _7_shoftim_19_txt, _7_shoftim_20_txt, _7_shoftim_21_txt,
      _8_shemuel_a_01_txt, _8_shemuel_a_02_txt, _8_shemuel_a_03_txt, _8_shemuel_a_04_txt,
      _8_shemuel_a_05_txt, _8_shemuel_a_06_txt, _8_shemuel_a_07_txt, _8_shemuel_a_08_txt,
      _8_shemuel_a_09_txt, _8_shemuel_a_10_txt, _8_shemuel_a_11_txt, _8_shemuel_a_12_txt,
      _8_shemuel_a_13_txt, _8_shemuel_a_14_txt, _8_shemuel_a_15_txt, _8_shemuel_a_16_txt,
      _8_shemuel_a_17_txt, _8_shemuel_a_18_txt, _8_shemuel_a_19_txt, _8_shemuel_a_20_txt,
      _8_shemuel_a_21_txt)
}

private fun init__6_yehoshua_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-17.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-17.txt")

private fun init__6_yehoshua_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-18.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-18.txt")

private fun init__6_yehoshua_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-19.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-19.txt")

private fun init__6_yehoshua_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-20.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-20.txt")

private fun init__6_yehoshua_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-21.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-21.txt")

private fun init__6_yehoshua_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-22.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-22.txt")

private fun init__6_yehoshua_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-23.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-23.txt")

private fun init__6_yehoshua_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-24.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-24.txt")

private fun init__7_shoftim_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-01.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-01.txt")

private fun init__7_shoftim_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-02.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-02.txt")

private fun init__7_shoftim_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-03.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-03.txt")

private fun init__7_shoftim_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-04.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-04.txt")

private fun init__7_shoftim_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-05.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-05.txt")

private fun init__7_shoftim_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-06.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-06.txt")

private fun init__7_shoftim_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-07.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-07.txt")

private fun init__7_shoftim_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-08.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-08.txt")

private fun init__7_shoftim_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-09.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-09.txt")

private fun init__7_shoftim_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-10.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-10.txt")

private fun init__7_shoftim_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-11.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-11.txt")

private fun init__7_shoftim_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-12.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-12.txt")

private fun init__7_shoftim_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-13.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-13.txt")

private fun init__7_shoftim_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-14.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-14.txt")

private fun init__7_shoftim_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-15.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-15.txt")

private fun init__7_shoftim_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-16.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-16.txt")

private fun init__7_shoftim_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-17.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-17.txt")

private fun init__7_shoftim_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-18.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-18.txt")

private fun init__7_shoftim_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-19.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-19.txt")

private fun init__7_shoftim_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-20.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-20.txt")

private fun init__7_shoftim_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_7_shoftim-21.txt\")") as String, rawPath =
    "allChapters/_7_shoftim-21.txt")

private fun init__8_shemuel_a_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-01.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-01.txt")

private fun init__8_shemuel_a_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-02.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-02.txt")

private fun init__8_shemuel_a_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-03.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-03.txt")

private fun init__8_shemuel_a_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-04.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-04.txt")

private fun init__8_shemuel_a_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-05.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-05.txt")

private fun init__8_shemuel_a_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-06.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-06.txt")

private fun init__8_shemuel_a_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-07.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-07.txt")

private fun init__8_shemuel_a_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-08.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-08.txt")

private fun init__8_shemuel_a_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-09.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-09.txt")

private fun init__8_shemuel_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-10.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-10.txt")

private fun init__8_shemuel_a_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-11.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-11.txt")

private fun init__8_shemuel_a_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-12.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-12.txt")

private fun init__8_shemuel_a_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-13.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-13.txt")

private fun init__8_shemuel_a_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-14.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-14.txt")

private fun init__8_shemuel_a_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-15.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-15.txt")

private fun init__8_shemuel_a_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-16.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-16.txt")

private fun init__8_shemuel_a_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-17.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-17.txt")

private fun init__8_shemuel_a_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-18.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-18.txt")

private fun init__8_shemuel_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-19.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-19.txt")

private fun init__8_shemuel_a_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-20.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-20.txt")

private fun init__8_shemuel_a_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-21.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-21.txt")

public actual val SharedRes.assets.allChapters._6_yehoshua_17_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_17_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_18_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_18_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_19_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_19_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_20_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_20_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_21_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_21_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_22_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_22_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_23_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_23_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_24_txt: AssetResource
  get() = CommonMainAssets17._6_yehoshua_24_txt

public actual val SharedRes.assets.allChapters._7_shoftim_01_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_01_txt

public actual val SharedRes.assets.allChapters._7_shoftim_02_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_02_txt

public actual val SharedRes.assets.allChapters._7_shoftim_03_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_03_txt

public actual val SharedRes.assets.allChapters._7_shoftim_04_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_04_txt

public actual val SharedRes.assets.allChapters._7_shoftim_05_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_05_txt

public actual val SharedRes.assets.allChapters._7_shoftim_06_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_06_txt

public actual val SharedRes.assets.allChapters._7_shoftim_07_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_07_txt

public actual val SharedRes.assets.allChapters._7_shoftim_08_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_08_txt

public actual val SharedRes.assets.allChapters._7_shoftim_09_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_09_txt

public actual val SharedRes.assets.allChapters._7_shoftim_10_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_10_txt

public actual val SharedRes.assets.allChapters._7_shoftim_11_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_11_txt

public actual val SharedRes.assets.allChapters._7_shoftim_12_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_12_txt

public actual val SharedRes.assets.allChapters._7_shoftim_13_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_13_txt

public actual val SharedRes.assets.allChapters._7_shoftim_14_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_14_txt

public actual val SharedRes.assets.allChapters._7_shoftim_15_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_15_txt

public actual val SharedRes.assets.allChapters._7_shoftim_16_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_16_txt

public actual val SharedRes.assets.allChapters._7_shoftim_17_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_17_txt

public actual val SharedRes.assets.allChapters._7_shoftim_18_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_18_txt

public actual val SharedRes.assets.allChapters._7_shoftim_19_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_19_txt

public actual val SharedRes.assets.allChapters._7_shoftim_20_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_20_txt

public actual val SharedRes.assets.allChapters._7_shoftim_21_txt: AssetResource
  get() = CommonMainAssets17._7_shoftim_21_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_01_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_01_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_02_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_02_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_03_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_03_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_04_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_04_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_05_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_05_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_06_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_06_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_07_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_07_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_08_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_08_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_09_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_09_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_10_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_10_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_11_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_11_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_12_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_12_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_13_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_13_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_14_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_14_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_15_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_15_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_16_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_16_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_17_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_17_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_18_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_18_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_19_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_19_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_20_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_20_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_21_txt: AssetResource
  get() = CommonMainAssets17._8_shemuel_a_21_txt
